import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import $ from "jquery";
import "datatables.net-dt";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-dt/css/jquery.dataTables.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import * as XLSX from "xlsx";
import withTokenCheck from "../../withTokenCheck";

const emptyForm = { codigo: "", nombre: "", link: "" };

const Origenes = ({ token }) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [editing, setEditing] = useState(null);
    const [form, setForm] = useState(emptyForm);
    const [file, setFile] = useState(null);
    const tableRef = useRef(null);

    const fetchRows = useCallback(() => {
        if (!token) return;
        axios
            .get("/origen", { headers: { Authorization: `Bearer ${token}` } })
            .then((response) => {
                setRows(response.data);
                setLoading(false);
            })
            .catch(() => setLoading(false));
    }, [token]);

    useEffect(fetchRows, [fetchRows]);

    useEffect(() => {
        if (!loading && tableRef.current) {
            const table = $(tableRef.current).DataTable({
                destroy: true,
                paging: true,
                ordering: true,
                info: true,
                language: { url: "//cdn.datatables.net/plug-ins/1.13.1/i18n/es-ES.json" },
                dom: "<'row'<'col-sm-2'l><'col-sm-6'B><'col-sm-4'f>><'row'<'col-sm-12'tr>><'row'<'col-sm-6 text-right'i><'col-sm-6'p>>",
                buttons: [{ extend: "excel", className: "btn-success", text: "Excel", extension: ".xlsx" }],
            });
            return () => table.destroy();
        }
    }, [loading, rows]);

    const openCreate = () => {
        setEditing(null);
        setForm(emptyForm);
        setModalOpen(true);
    };

    const openEdit = (row) => {
        setEditing(row);
        setForm({
            codigo: row.codigo || "",
            nombre: row.nombre || "",
            link: row.link || "",
        });
        setModalOpen(true);
    };

    const save = (event) => {
        event.preventDefault();
        const request = editing
            ? axios.put(`/origen/${editing.id}`, form, { headers: { Authorization: `Bearer ${token}` } })
            : axios.post("/origen", form, { headers: { Authorization: `Bearer ${token}` } });

        request
            .then(() => {
                Swal.fire("Guardado", "El origen fue guardado.", "success").then(() => {
                    setModalOpen(false);
                    fetchRows();
                });
            })
            .catch((error) => {
                const message = error.response?.data?.message || "No fue posible guardar el origen.";
                Swal.fire("Error", message, "error");
            });
    };

    const remove = (row) => {
        axios
            .delete(`/origen/${row.id}`, { headers: { Authorization: `Bearer ${token}` } })
            .then(() => Swal.fire("Eliminado", "El origen fue eliminado.", "success").then(fetchRows))
            .catch(() => Swal.fire("Error", "No fue posible eliminar el origen.", "error"));
    };

    const downloadTemplate = () => {
        const worksheet = XLSX.utils.json_to_sheet([{ codigo: "", nombre: "", link: "" }], {
            header: ["codigo", "nombre", "link"],
        });
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "origenes");
        XLSX.writeFile(workbook, "plantilla_origenes.xlsx");
    };

    const uploadFile = () => {
        if (!file) {
            Swal.fire("Archivo requerido", "Seleccione un archivo para cargar.", "warning");
            return;
        }

        const formData = new FormData();
        formData.append("archivo", file);

        axios
            .post("/origen/import", formData, {
                headers: { Authorization: `Bearer ${token}`, "Content-Type": "multipart/form-data" },
            })
            .then((response) => {
                const data = response.data;
                Swal.fire(
                    "Carga finalizada",
                    `Insertados: ${data.insertados}. Actualizados: ${data.actualizados}. Omitidos: ${data.omitidos}.`,
                    data.errores?.length ? "warning" : "success"
                ).then(fetchRows);
            })
            .catch(() => Swal.fire("Error", "No fue posible importar el archivo.", "error"));
    };

    return (
        <>
            <Helmet>
                <title>Origenes</title>
            </Helmet>
            <div style={{ maxWidth: "1200px", margin: "50px auto" }}>
                <div className="d-flex gap-2 mb-3 flex-wrap">
                    <Button color="primary" onClick={openCreate}>Crear</Button>
                    <Button color="success" onClick={downloadTemplate}>Descargar plantilla</Button>
                    <input className="form-control" style={{ maxWidth: 360 }} type="file" accept=".xlsx,.xls,.csv" onChange={(event) => setFile(event.target.files[0])} />
                    <Button color="secondary" onClick={uploadFile}>Cargar archivo</Button>
                </div>
                {loading ? (
                    <div>Cargando...</div>
                ) : (
                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <table ref={tableRef} className="table" style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th>Editar</th>
                                    <th>Eliminar</th>
                                    <th>Codigo</th>
                                    <th>Nombre</th>
                                    <th>Link</th>
                                    <th>Usuario creacion</th>
                                    <th>Fecha creacion</th>
                                    <th>Usuario actualizacion</th>
                                    <th>Fecha actualizacion</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row) => (
                                    <tr key={row.id}>
                                        <td><Button color="secondary" onClick={() => openEdit(row)}>Editar</Button></td>
                                        <td><Button color="danger" onClick={() => remove(row)}>Eliminar</Button></td>
                                        <td>{row.codigo}</td>
                                        <td>{row.nombre}</td>
                                        <td>{row.link || ""}</td>
                                        <td>{row.created_by?.name || "no existe informacion"}</td>
                                        <td>{row.created_at || "Informacion no disponible"}</td>
                                        <td>{row.updated_by?.name || "no existe informacion"}</td>
                                        <td>{row.updated_at || "Informacion no disponible"}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
                <ModalHeader toggle={() => setModalOpen(!modalOpen)}>
                    {editing ? "Editar origen" : "Crear origen"}
                </ModalHeader>
                <ModalBody>
                    <label>Codigo</label>
                    <input className="form-control mb-3" value={form.codigo} onChange={(event) => setForm({ ...form, codigo: event.target.value })} />
                    <label>Nombre</label>
                    <input className="form-control mb-3" value={form.nombre} onChange={(event) => setForm({ ...form, nombre: event.target.value })} />
                    <label>Link</label>
                    <input className="form-control" value={form.link} onChange={(event) => setForm({ ...form, link: event.target.value })} />
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={save}>Guardar</Button>
                    <Button color="danger" onClick={() => setModalOpen(false)}>Cancelar</Button>
                </ModalFooter>
            </Modal>
        </>
    );
};

export default withTokenCheck(Origenes);
